import { useQuery } from '@tanstack/react-query'

import { useCurrentOrgId } from '@/stores/authStore'
import request from './request'
import { zodServiceSettingResponseValidator, type ServiceSettingsResponse } from './types/Service'

/* ---------------------------- Organization Services Settings ---------------------------- */

const getOrganizationServicesSettings = async () => {
  const res = await request<ServiceSettingsResponse[]>({
    endpoint: '/organization/services-preferences',
    method: 'GET'
  })
  if (res.success) zodServiceSettingResponseValidator(res.data)
  return res
}

export const useGetOrganizationServicesSettings = () => {
  const currOrgId = useCurrentOrgId()
  return useQuery({
    queryKey: [currOrgId, 'organization', 'services-preferences'],
    queryFn: getOrganizationServicesSettings
  })
}

export const updateOrganizationServicesSettings = async (
  organizationServicePreferenceId: ServiceSettingsResponse['id'],
  value: ServiceSettingsResponse['value']
) => await request({
  endpoint: '/organization/services-preferences',
  method: 'PUT',
  body: { organizationServicePreferenceId, value }
})
